<template>
  <ConfirmationModal
    bodyText=""
    :cancelText="cancelButtonText"
    :continueText="continueButtonText"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :mainActionAttention="true"
  >
    <p>
      <MarkdownInline
        :mdTemplate="eligibleMessage"
      />
    </p>
    <p v-if="eligibleDetailsText1">
      <MarkdownInline
        :mdTemplate="eligibleDetailsText1"
      />
    </p>
    <p v-if="eligibleDetailsText2">
      <MarkdownInline
        :mdTemplate="eligibleDetailsText2"
      />
    </p>
    <p
      v-if="eligibleCount > 0"
    >
      <MarkdownInline
        :mdTemplate="warningText"
      />
    </p>
  </ConfirmationModal>
</template>

<script>
import { MarkdownInline } from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import Constants, {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import ModalEventBus from 'components/Modal/ModalEventBus';
import _ from 'lodash';
import pluralize from 'pluralize';

const storeModule = StoreModuleMap[ItemTypeConsts.system];
const { error, success } = Constants;

export default {
  name: 'SystemInsightsActionModal',

  components: {
    ConfirmationModal,
    MarkdownInline,
  },

  props: {
    allSystemsEligibleText: {
      type: String,
      required: true,
    },
    continueText: {
      type: String,
      required: true,
    },
    eligibleCount: {
      type: Number,
      required: true,
    },
    eligibleDetailsText1: {
      type: String,
      required: true,
    },
    eligibleDetailsText2: {
      type: String,
      required: true,
    },
    headerText: {
      type: String,
      required: true,
    },
    ineligibleSystems: {
      type: Array,
      required: true,
    },
    newState: {
      type: String,
      required: true,
    },
    noSystemsEligibleText: {
      type: String,
      required: true,
    },
    someSystemsEligibleText: {
      type: String,
      required: true,
    },
    warningText: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters(storeModule, {
      selectedItems: 'getSelectedItems',
    }),

    cancelButtonText() {
      return this.eligibleCount > 0 ? 'cancel' : '';
    },

    continueButtonText() {
      return this.eligibleCount > 0 ? this.continueText : 'ok';
    },

    eligibleMessage() {
      if (this.eligibleCount === 0) {
        return this.noSystemsEligibleText;
      }

      if (this.eligibleCount === this.selectedItems.length) {
        return this.allSystemsEligibleText;
      }

      return this.someSystemsEligibleText;
    },
  },

  methods: {
    ...mapActions(storeModule, [
      'unselectItems',
      'unselectAllItems',
      'updateItems',
    ]),

    handleContinue() {
      // If there is no work to do, they just clicked 'ok' so just close the modal
      if (this.eligibleCount === 0) {
        ModalEventBus.close();
        return;
      }

      this.unselectItems({ ids: this.ineligibleSystems.map(item => item.id) });

      ModalEventBus.close();
      this.update();
    },

    update() {
      this.updateItems({
        ids: this.selectedItems,
        attributes: {
          systemInsights: {
            state: this.newState,
          },
        },
      }).then((response) => {
        let notifyType;
        let notifyMessage;
        if (_.get(response, 'numSuccess')) {
          notifyType = success;
          notifyMessage = (this.eligibleCount === 1)
            ? '1 system was successfully updated.'
            : `${response.numSuccess} of ${this.eligibleCount} systems were successfully updated.`;
          this.unselectAllItems();
        } else {
          notifyType = error;
          notifyMessage = `Error updating ${pluralize('system', this.eligibleCount)}.`;
        }
        notify(notifyType, notifyMessage);
      });
    },
  },
};
</script>
